<template>
  <div class="add_test__step-3">
    <ProductListTable :step="step" />

    <div class="flex items-start lab_test__note mt-5 text-danger text-sm font-bold">
      <vs-checkbox ref="checkNote" v-model="step3.checkNote" />
      <p>
        By checking this box, I acknowledge that SeedSuite is not a lab and therefore cannot guarantee the experience I receive with the lab I have chosen. I agree that the information provided is
        accurate and true. I also agree that lab pricing may change to align with state regulations or promotional purposes. Finally, I understand that any changes in lab pricing or the experience I
        have with the lab I have chosen does not impact SeedSuite’s terms of service.
      </p>
    </div>
    <div class="flex items-start lab_test__note mt-5 text-danger text-sm font-bold" v-if="lab">
      <vs-checkbox ref="checkScheduleContact" v-model="step3.checkScheduleContact" />
      <p>I will contact {{ lab.name }} at {{ lab.mobile }} to schedule a drop off</p>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ProductListTable from '@/views/lab-tests/components/ProductListTable.vue'

export default {
  name: 'AddTestStep3',
  components: {
    ProductListTable
  },
  props: {
    step3: {
      checkNote: Boolean,
      checkScheduleContact: Boolean
    },
    step2: {
      lab: Number
    }
  },

  data() {
    return {
      step: 3
    }
  },

  computed: {
    ...mapState('lab', ['labs']),

    lab: {
      get() {
        return this.labs.find(x => x.id === this.step2.lab)
      }
    }
  }
}
</script>

<style lang="scss">
.add_test__step-3 {
  input:focus + span.checkbox_x {
    &.vs-checkbox {
      border: 2px solid green !important;
    }
  }
}
</style>
